import { Box, Chip, styled, TableCell } from '@mui/material';

export const ExpandedRowContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '24px',
  padding: '16px 24px',
  backgroundColor: theme.palette.background.default,
}));

export const ScreenshotThumbnail = styled(Box)({
  flexShrink: 0,
  width: 200,
  display: 'flex',
  alignItems: 'flex-start',
});

export const SectionColumn = styled(Box)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const SectionTitle = styled(Box)({
  fontWeight: 600,
  fontSize: '14px',
  marginBottom: '4px',
});

export const InfoRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '13px',
});

export const InfoLabel = styled('span')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '13px',
  color: theme.palette.text.secondary,
}));

export const ExpandCell = styled(TableCell)({
  width: 28,
  padding: '0 2px',
});

export const ExpandedCell = styled(TableCell)({
  padding: 0,
});

export const ExternalToolsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  padding: '8px 24px 16px',
  backgroundColor: theme.palette.background.default,
}));

export const ExpandedSecondRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '24px',
  padding: '0 24px 8px',
  backgroundColor: theme.palette.background.default,
}));

export const ExternalChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  borderRadius: '8px',
  letterSpacing: '-0.03em',
  '& .MuiChip-icon': { color: theme.palette.common.white },
  '&:hover': { backgroundColor: theme.palette.secondary.dark },
}));
